import React, { useEffect, useRef, useState } from "react";

const Experiencia = () => {
  const [visible, setVisible] = useState(false);
  const seccionRef = useRef(null);

  useEffect(() => {
    const observarSeccion = new IntersectionObserver(
      ([entrada]) => {
        if (entrada.isIntersecting) {
          setVisible(true);
          observarSeccion.disconnect();
        }
      },
      {
        threshold: 0.15,
      }
    );

    if (seccionRef.current) {
      observarSeccion.observe(seccionRef.current);
    }

    return () => observarSeccion.disconnect();
  }, []);

  const experiencias = [
    {
      titulo: "Scania Argentina",
      institucion: "Pasantía",
      fecha: "2026 - Actualidad",
      descripcion:
        "Aplico los conocimientos adquiridos durante mi formación e incorporo nuevas herramientas y tecnologías en el desarrollo de soluciones y procesos del entorno laboral.",
    },
    {
      titulo: "Advance Soccer Training",
      institucion: "Práctica Profesional",
      fecha: "2025",
      descripcion:
        "Desarrollo de un sitio web con React, logrando una identidad digital más sólida para la empresa. Integré todas sus páginas externas y herramientas existentes en un único lugar, creando un sitio web práctico, claro y con la información organizada de manera eficiente, lo que facilita la navegación y mejora la experiencia de los usuarios.",
    },
  ];

  return (
    <>
      <style>
        {`
          @keyframes aparecerDesdeAbajo {
            from {
              opacity: 0;
              transform: translateY(50px);
            }

            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .experiencia-animacion {
            opacity: 0;
          }

          .experiencia-visible {
            animation: aparecerDesdeAbajo 0.8s ease-out forwards;
          }

          .experiencia-titulo {
            animation-delay: 0.1s;
          }

          .experiencia-card-1 {
            animation-delay: 0.3s;
          }

          .experiencia-card-2 {
            animation-delay: 0.5s;
          }

          @media (prefers-reduced-motion: reduce) {
            .experiencia-animacion {
              opacity: 1;
              animation: none;
            }
          }
        `}
      </style>

      <section
        id="experiencias"
        ref={seccionRef}
        className="px-4 py-0 sm:px-6"
      >
        <div className="mx-auto max-w-[1230px] pb-20">
          <h2
            className={`experiencia-animacion experiencia-titulo relative mb-5 text-center text-[35px] font-black text-[#1c2143] sm:text-[50px] ${
              visible ? "experiencia-visible" : ""
            }`}
          >
            Experiencias

            <span className="mx-auto block h-1 w-[90px] rounded-full bg-[#1c2143] sm:w-[120px]" />
          </h2>

          <div className="space-y-8">
            {experiencias.map((experiencia, index) => (
              <article
                key={experiencia.titulo}
                className={`experiencia-animacion ${
                  index === 0
                    ? "experiencia-card-1"
                    : "experiencia-card-2"
                } rounded-[30px] border-2 border-[#1c2143] bg-transparent p-5 shadow-[0_20px_60px_rgba(28,33,67,0.15)] backdrop-blur-[20px] transition duration-300 hover:-translate-y-1 hover:shadow-[0_0_40px_rgba(28,33,67,0.25)] sm:p-10 ${
                  visible ? "experiencia-visible" : ""
                }`}
              >
                <div className="flex flex-col justify-between gap-4 md:flex-row md:items-start">
                  <div>
                    <h3 className="text-2xl font-bold text-[#1c2143] sm:text-2xl">
                      {experiencia.titulo}
                    </h3>

                    <h4 className="mt-2 text-xl font-semibold text-[#2f5972]">
                      {experiencia.institucion}
                    </h4>
                  </div>

                  <p className="text-lg font-semibold text-[#1c2143] sm:text-xl">
                    {experiencia.fecha}
                  </p>
                </div>

                <p className="mt-3 text-base leading-8 text-black sm:text-xl">
                  {experiencia.descripcion}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Experiencia;